import { Stack } from "@chakra-ui/react";
import { Outlet } from "react-router";

import NavBar from "../../../components/nav/NavBar";

const VaultLayout = () => {
  return (
    <Stack as="main" bgColor="background" direction={{ base: "column", lg: "row" }} minH={"100vh"} h="full">
      <NavBar>
        <Outlet />
      </NavBar>
    </Stack>
  );
};

export default VaultLayout;
